import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SettingProps } from "./Settings";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import UserController from "../../controller/UserController";

const PasswordTypeSetting = ({
  passwordType,
  setPasswordType,
  setStep,
}: SettingProps) => {
  const navigate = useNavigate();
  const [isCheck, setIsCheck] = useState<number>(-1);

  const setPasswordData = (passwordType: string) => {
    //setPasswordType!(passwordType);
    //setStep!(2);
  };

  const getUserInfo = async () => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData.use_password === 0) {
      setIsCheck(0);
    } else if (oUserData.use_password === 1) {
      setIsCheck(1);
    }
  }

  const setUserPasswordType = async () => {
    if (isCheck === 0) {
      setIsCheck(1);
      updateUserPassword('1234');
    } else if (isCheck === 1) {
      setIsCheck(0);
      updateUserPassword('');
    }
  }

  const updateUserPassword = async (sPassword:string) => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (oUserData) {
        let oRes: any = await UserController.setLoginPassword({ use_password: true, car_uuid: oUserData.car_uuid, login_password: sPassword
      });
      if (oRes && oRes.data && oRes.data.success === true) {
        if(sPassword === ''){
          oUserData.use_password = 0;
          await AsyncLocalStorage.setItem("accountSetting", JSON.stringify(oUserData));
        } else {
          oUserData.use_password = 1;
          await AsyncLocalStorage.setItem("accountSetting", JSON.stringify(oUserData));
        }
      }
    }
  }

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <div className="wrapper">
      <div className="listWrap">
        <div className={`buttonBorder ${isCheck === 1 && "active"}`}>
          <button onClick={() => setUserPasswordType()}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_user.svg`} alt="user" />
            <h1>로그인 할 때</h1>
          </button>
        </div>
        {/*
        <div className="buttonBorder">
          <button onClick={() => setPasswordData("payment")}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_pay.svg`} alt="pay" />
            <h1>결제 할 때</h1>
          </button>
        </div>
        */}
      </div>
      <div className="buttonBorder long">
        <button
          onClick={() =>
            navigate("/payment/password", { state: { passwordType: "edit" } })
          }
        >
          <h1>비밀번호 변경하기</h1>
        </button>
      </div>
    </div>
  );
};
export default PasswordTypeSetting;
